module.exports = __webpack_public_path__ + "static/img/label-01.b2097ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-01.png
// module id = /viO
// module chunks = 31